const galleryImages = document.querySelectorAll('.gallery-image');

const observer = new IntersectionObserver((
    entries) => {
        entries.forEach(entry => {
            entry.target.classList.toggle('in-view', entry.isIntersecting)
            if (entry.isIntersecting) {
                observer.unobserve(entry.target)
            }   
        })
    }, {
        threshold: 0.8,
    }
);

galleryImages.forEach(image => {
    observer.observe(image);
})
